import { FEATURE_FLAGS } from '../../constants/general';
import {
	INVENTORY_RESTRICTED_BRANDS,
	MAX_DEFAULT_INVENTORY_QUANTITY,
	MAX_RESTRICTED_INVENTORY_QUANTITY
} from '../../constants/restricted-inventory';
import { useFeature } from '../../hooks/features/features.hooks';

// To be consumed by the QuantityInput component's maxQuantity prop
export const useRestrictedInventory = (brand: string): { maxQuantity: number; isRestricted: boolean } => {
	const isRestricted = INVENTORY_RESTRICTED_BRANDS.includes(brand.toLowerCase());
	const areInventoryRestrictionsActive = useFeature(FEATURE_FLAGS.INVENTORY_RESTRICTIONS);

	return isRestricted && areInventoryRestrictionsActive
		? { maxQuantity: MAX_RESTRICTED_INVENTORY_QUANTITY, isRestricted: true }
		: { maxQuantity: MAX_DEFAULT_INVENTORY_QUANTITY, isRestricted: false };
};
